export const SOCIAL_MEDIA = [
    {
        name: 'Instagram',
        url: 'https://www.instagram.com/star_rv_world',
        handle: '@star_rv_world',
    },
    {
        name: 'Facebook',
        url: 'https://www.facebook.com/StarRVWorld',
        handle: 'StarRVWorld',
    },
    {
        name: 'YouTube',
        url: 'https://www.youtube.com/@starrvtv',
        handle: '@starrvtv',
    },
];
